import h from '../../libs/jsx';
import { initAccordions } from '../utils';

import { generateValidId } from '../utils/dom';

export default class FilterQuestionnaire {
  constructor(options = {}) {
    ({
      filterValues: this.filterValueEntities = [],
      selectedValues: this.selectedFilterValueCodes,
      showCustomerDataAgain: this.showCustomerDataAgain,
      showCustomerData: this.showCustomerData,
    } = options);
    this.filterTree = [];
    this.container = document.getElementById('questionnaire');
    this.form = document.getElementById('questionnaire-form');
    this.resetButton = document.getElementById('reset-filters');
    this.init();
  }

  init() {
    this.filterTree = this.getFilterHierarchy();
    this.renderFilters();
    this.initRadioButtons();
    this.initForm();
    this.initResetButton();
    this.updateResetButton();
    this.handleRequiredChecboxes();
  }

  updateGroupInvalidClasses() {
    this.form.querySelectorAll('.group-invalid').forEach(group => {
      const invalidFields = group.querySelectorAll('input:invalid');
      if (invalidFields.length === 0) {
        group.classList.remove('group-invalid');
      }
    });
  }

  initForm() {
    const form = this.form;
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      form.classList.add('validation-highlighted');
      this.updateGroupInvalidClasses();
      const invalidFields = [];

      [...form.elements].forEach(field => {
        if (!field.checkValidity()) {
          invalidFields.push(field.name);
        }
      });

      invalidFields.forEach(fieldName => {
        const field = form.querySelector(`[name="${fieldName}"]`);
        document.querySelectorAll('.ac').forEach(parent => {
          if (parent.contains(field)) {
            parent.classList.add('group-invalid');
          }
        });
      });

      // scroll the first invalid group to screen view
      const firstInvalidGroup = form.querySelector('.group-invalid');
      if (firstInvalidGroup) {
        firstInvalidGroup.scrollIntoView({ behavior: 'smooth' });
      }

      if (invalidFields.length == 0) {
        if (window.customerDialog && this.showCustomerData) {
          const shownNow = window.customerDialog.show();
          if (shownNow) {
            // unmark the pontential validation errors
            setTimeout(() => {
              const jqForm = jQuery(form).validate();
              for (const field of jqForm.errorList) {
                jqForm.settings.unhighlight.call(
                  jqForm,
                  field.element,
                  jqForm.settings.errorClass,
                  jqForm.settings.validClass
                );
              }
            }, 10);
          }

          if ((typeof jQuery(form).valid === 'function' && !$(form).valid()) || this.showCustomerDataAgain) {
            this.showCustomerDataAgain = false;
            return;
          } else {
            form.submit();
          }
        } else {
          form.submit();
        }
      } else {
        return;
      }
    });
  }

  getFilterHierarchy() {
    const groupedByFilterCode = this.filterValueEntities.reduce((acc, item) => {
      const filterCode = item.FILTER_CODE;
      if (!acc[filterCode]) {
        acc[filterCode] = { filters: [], values: [], parentKey: null, filter: {} };
      }

      acc[filterCode].parentKey = item.FILTER_PARENT_KEY;
      const {
        FILTER_CODE,
        FILTER_DESCRIPTION,
        FILTER_ID,
        FILTER_LOGIC,
        FILTER_MEDIA_URL,
        FILTER_VALUE_MEDIA_URL,
        FILTER_NAME,
        FILTER_ORDER,
        FILTER_REQUIRED,
        FILTER_EXPANDED,
      } = item;

      acc[filterCode].filter = {
        FILTER_CODE,
        FILTER_DESCRIPTION,
        FILTER_ID,
        FILTER_LOGIC,
        FILTER_MEDIA_URL,
        FILTER_VALUE_MEDIA_URL,
        FILTER_NAME,
        FILTER_ORDER,
        FILTER_REQUIRED,
        FILTER_EXPANDED,
      };

      if (item.FILTER_VALUE_ID) {
        acc[filterCode].values.push(item);
      }

      return acc;
    }, {});

    const tree = [];
    this.populateTree(groupedByFilterCode, '', tree);
    return tree;
  }

  populateTree(groupedByFilterCode, parentKey, accumulator = []) {
    Object.keys(groupedByFilterCode).forEach(filterCode => {
      if (groupedByFilterCode[filterCode].parentKey === parentKey) {
        const filter = groupedByFilterCode[filterCode].filter;
        const children = [];
        this.populateTree(groupedByFilterCode, filter.FILTER_CODE, children);
        filter.children = children;
        filter.values = groupedByFilterCode[filterCode].values || [];
        accumulator.push(filter);
      }
    });
  }

  renderFilters() {
    const filters = [];
    for (const filter of this.filterTree) {
      filters.push(this.renderFilter(filter));
    }

    this.container.append(<div class="filter-assistant-accordion-container">{filters}</div>);
    initAccordions('filter-assistant-accordion-value-container');
  }

  renderFilter(filter) {
    const childrenRendered = [];
    if (filter.children) {
      for (const child of filter.children) {
        childrenRendered.push(this.renderFilter(child));
      }
    }
    const items = filter.values.map((value, i) => {
      const id = this.getValueId(value);
      const imageDom = value.FILTER_VALUE_MEDIA_URL ? (
        <div class="product-image">
          <img
            src={`images_dynam/tp_liste/${value.FILTER_VALUE_MEDIA_URL}`}
            alt=""
            loading="lazy"
            width="450px"
            height="300px"
            draggable="false"
          />
        </div>
      ) : (
        ''
      );

      return (
        <label class="product-wrapper" for={id}>
          <input
            type={filter.FILTER_LOGIC === 'OR' ? 'radio' : 'checkbox'}
            class={filter.FILTER_REQUIRED && filter.FILTER_LOGIC === 'AND' ? 'checbox-required plain' : 'plain'}
            id={id}
            name={`filter-${filter.FILTER_ID}`}
            {...(filter.FILTER_REQUIRED ? { required: true } : {})}
            onChange={event => this.filterValueChanged(value)}
            value={value.FILTER_VALUE_ID}
            checked={this.selectedFilterValueCodes.includes(value.FILTER_VALUE_CODE)}
          />
          <div class="product">
            {imageDom}
            <div class="product-name">{value.FILTER_VALUE_NAME}</div>
            <div class="product-desc">{value.FILTER_VALUE_DESCRIPTION}</div>
          </div>
        </label>
      );
    });

    const filterObject = filter;
    const imageDom = filterObject.FILTER_MEDIA_URL ? (
      <div class="product-group-image">
        <img src={`images_dynam/tp_liste/${filterObject.FILTER_MEDIA_URL}`} alt="" />
      </div>
    ) : (
      ''
    );

    const acClass = `ac ${filter.FILTER_EXPANDED ? 'accordion-opened-default' : ''}`;

    return (
      <div class="filter-assistant-accordion-value-container">
        <div class={acClass}>
          <div class="ac-header">
            <div class="ac-trigger product-group product-group--compact">
              {imageDom}
              <div class="product-group-desc">
                <div class="product-group-name">{filterObject.FILTER_NAME}</div>
                <div class="product-group-description">{filterObject.FILTER_DESCRIPTION}</div>
              </div>
            </div>
          </div>
          <div class="ac-panel">
            {childrenRendered.length > 0 && <div class="">{childrenRendered}</div>}
            <div class="products-container per-row-max-count-5-xl">{items}</div>
          </div>
        </div>
      </div>
    );
  }

  getValueId(value) {
    return `ev-${generateValidId(value.FILTER_CODE)}-${generateValidId(value.FILTER_VALUE_CODE)}`;
  }

  filterValueChanged(value) {
    this.handleRequiredChecboxes();
    this.updateGroupInvalidClasses();
    this.updateResetButton();
  }

  handleRequiredChecboxes() {
    this.form.querySelectorAll('.checbox-required').forEach(checkbox => {
      const hasSomeInputChecked = !!checkbox.parentNode.parentNode.querySelectorAll('input[type="checkbox"]:checked')
        .length;
      if (hasSomeInputChecked) {
        checkbox.removeAttribute('required');
      } else {
        checkbox.setAttribute('required', 'required');
      }
    });
  }

  resetAllSelections() {
    this.form.querySelectorAll('input').forEach(input => {
      input.checked = false;
      if (input.classList.contains('required')) {
        input.setAttribute('required', 'required');
      }
    });
  }

  initResetButton() {
    this.resetButton.addEventListener('click', e => {
      e.preventDefault();
      this.resetAllSelections();
      this.updateResetButton();
    });
  }

  initRadioButtons() {
    const self = this;
    const labels = this.form.querySelectorAll('label.product-wrapper');

    labels.forEach(label => {
      label.addEventListener('click', function (event) {
        const radio = label.querySelector('input[type="radio"]');
        if (!radio) {
          return;
        }

        event.preventDefault();
        if (radio.checked) {
          setTimeout(() => {
            radio.checked = false;
            self.filterValueChanged();
          }, 0);
        } else {
          radio.checked = true;
          self.filterValueChanged();
        }
      });
    });
  }

  updateResetButton() {
    if (this.haveSomeFiltersSelected()) {
      this.resetButton.style.visibility = 'visible';
    } else {
      this.resetButton.style.visibility = 'hidden';
    }
  }

  haveSomeFiltersSelected() {
    return this.form.querySelectorAll('input:checked').length > 0;
  }
}
